import { useEffect, useState } from "react";

import { categoryService } from "../services/categoryService";

export default function useCategories(search = "")  {

    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);

    const [deletingId, setDeletingId] = useState(null);

    const [saving, setSaving] = useState(false);

    useEffect(() => {

        const timeout = setTimeout(() => {
            fetchCategories();
        }, 400);

        return () => clearTimeout(timeout);

    }, [search]);

    const fetchCategories = async () => {

        try {

            setLoading(true);

            const data = await categoryService.getCategories(search);
            console.log(data);

            setCategories(data || []);
            

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };



    const createCategory = async (data) => {

        setSaving(true);

        try {

            await categoryService.createCategory(data);

            await fetchCategories();

        } finally {

            setSaving(false);

        }

    };

    const updateCategory = async (id, data) => {

        setSaving(true);

        try {

            await categoryService.updateCategory(id, data);

            await fetchCategories();

        } finally {

            setSaving(false);

        }

    };

    const deleteCategory = async (id) => {

        const confirmed = window.confirm(
            "Are you sure you want to delete this category?"
        );

        if (!confirmed) return;

        try {

            setDeletingId(id);

            setCategories(prev => prev.filter(c => c.id !== id));
            await categoryService.deleteCategory(id);



        } catch (error) {

            console.error(error);

        } finally {

            setDeletingId(null);

        }

    };


    

  return {
      categories,
      loading,
      saving,
      deletingId,

      fetchCategories,

      createCategory,
      updateCategory,
      deleteCategory,
  };

}